// Scroll
NP.Scroll = (function( $ ) {
	function Scroll( pane ) {
		this.onEnd = $.Callbacks();
		this.pane = $( pane );
		this.evtBind();
	}

	Scroll.prototype.evtBind = function() {
		var that = this,
			timer,
			scrollHandler = NP.win[ 0 ] === this.pane[ 0 ] ? function() {
				if ( NP.doc.height() - NP.win.height() <= NP.win.scrollTop() ) {
					that.onEnd.fire();
				}
			} : function() {
				if ( that.pane[ 0 ].scrollHeight - that.pane.innerHeight() <= that.pane.scrollTop() ) {
					that.onEnd.fire();
				}
			};

		this.pane.scroll(function() {
			if ( timer ) {
				clearTimeout( timer );
				timer = null;
			}

			timer = setTimeout( scrollHandler, 200 );
		});
	};

	return Scroll;
}( jQuery ));

// ScrollToLoad
NP.ScrollToLoad = function() {
	var tplParser = NP.ns( 'Util.tplParser' ),
		hbParser = NP.ns( 'Util.hbParser' ),
		timer;

	function IEScrollClear(){
		jQuery( '.moreArticle' ).remove();
		jQuery( window ).unbind( '.toLoad' );
	}

	NP.ScrollToLoad.pane = jQuery( 'body' );
	NP.ScrollToLoad.target = jQuery( '.moreArticle' );
	
	if ( !NP.ScrollToLoad.pane.length || !NP.ScrollToLoad.target.length ) {
		return;
	}
	
	NP.onAfterTimelineLoad.add(function() {
		//alert('로딩중입니다...')
		clearTimeout( timer );
		timer = setTimeout(function() {

			if ( NP.ScrollToLoad.pane[ 0 ].scrollHeight >= jQuery( window ).height() || NP.isLast ) {
				if ( NP.isLast === undefined || NP.isLast ) {

					if ( !NP.Util.getParam( 'postTxtSeq' ) ) {
						if ( NP.dt.loc === 'group' ) {
							if( !jQuery( '.openServiceGroupInfo' ).length ) NP.timeline.append( tplParser( NP.tmpl.openGroup )( NP.dt ) );
						} else if( NP.dt.loc === 'characterguestbook' ){
							if( !jQuery( '.openServiceInfo' ).length ) NP.timeline.append( tplParser( NP.tmpl.openGuestbook )( NP.dt ) );
						}else if( NP.dt.loc === 'groupguestbook' ){
							if( !jQuery( '.openServiceGroupInfo' ).length ) NP.timeline.append( tplParser( NP.tmpl.openGroupGuestbook )( NP.dt ) );
						}else if( NP.dt.loc === 'groupdonate' || NP.dt.loc === 'groupsign' || NP.dt.loc == 'groupreceive' ){
							
						}else{
							if( !jQuery( '.openServiceInfo' ).length ) 
								NP.timeline.append( tplParser( NP.tmpl.open )( NP.dt ) );
						}
						
						

					}

					NP.ScrollToLoad.clear();
				}else if( NP.isLast ){
					NP.ScrollToLoad.clear();
				}
			}
			
			if( screen.height > jQuery( '#contents' ).height() ){
				NP.ScrollToLoad.onViewport.fire();
			}
			
			if( jQuery( 'body' ).scrollTop() !== 0 ) jQuery( 'body' ).scrollTop( jQuery( 'body' ).scrollTop() - 1 );
			if( jQuery( 'html' ).scrollTop() !== 0 ) jQuery( 'html' ).scrollTop( jQuery( 'html' ).scrollTop() - 1 );

		}, 500);


	});

	jQuery( window ).bind( 'scroll.toLoad', function() {
		if ( NP.isEnded || ( !NP.isLoading && NP.ScrollToLoad.target.offset().top < ( jQuery( 'body' ).scrollTop() || jQuery( 'html' ).scrollTop() ) + jQuery( window ).height() ) ) {
			if ( NP.isLast ) {
				if ( NP.dt.loc === 'group' ) {
					if( !jQuery( '.openServiceGroupInfo' ).length ) 
						NP.timeline.append( tplParser( NP.tmpl.openGroup )( NP.dt ) );
				} else if( NP.dt.loc === 'characterguestbook' ){
					if( !jQuery( '.openServiceInfo' ).length ) 
						NP.timeline.append( tplParser( NP.tmpl.openGuestbook )( NP.dt ) );
				}else if( NP.dt.loc === 'groupguestbook' ){
					if( !jQuery( '.openServiceGroupInfo' ).length ) 
						NP.timeline.append( tplParser( NP.tmpl.openGroupGuestbook )( NP.dt ) );
				}else if( NP.dt.loc === 'groupdonate' || NP.dt.loc === 'groupsign' || NP.dt.loc == 'groupreceive'){
					
				}else{
					if( !jQuery( '.openServiceInfo' ).length ) 
						NP.timeline.append( tplParser( NP.tmpl.open )( NP.dt ) );
				}

				NP.ScrollToLoad.clear();


				return;
			}

			NP.ScrollToLoad.onViewport.fire();
		}		
	});
};
NP.ScrollToLoad.clear = function() {

	NP.ScrollToLoad.target.remove();
	NP.ScrollToLoad.onViewport.empty();
	jQuery( window ).unbind( '.toLoad' );
};
if ( !NP.Util.getParam( 'postTxtSeq' ) ) {
	NP.ScrollToLoad();
} else {
	jQuery( '.moreArticle' ).remove();
}
NP.ScrollToLoad.onViewport = jQuery.Callbacks();
NP.ScrollToLoad.onViewport.add(function() {
	NP.Timeline.get( NP.Timeline.getLastNum() );
});
